var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Users_Follower',{staticClass:"loading-blur",attrs:{"user":_vm.fakeUser}})}
var staticRenderFns = []

export { render, staticRenderFns }